module.exports = __webpack_public_path__ + "img/zest1.e67dd340.png";